import api from '@pray/shared/utils/api';

import type { WarmupCampaign, WarmupCampaignStatus } from './types';

export type WarmupCampaignStatusChangeTarget = Extract<WarmupCampaignStatus, 'active' | 'disabled' | 'done'>;

export async function changeWarmupCampaignStatus({
  artistId,
  warmupCampaignId,
  targetStatus,
}: {
  artistId: string;
  warmupCampaignId: string;
  targetStatus: WarmupCampaignStatusChangeTarget;
}): Promise<{ object: WarmupCampaign }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupCampaignId) throw new Error('Warmup campaign ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupCampaignId}/status`;
  const response = await api.executePatchRequest<{ data: { object: WarmupCampaign } }>(url, {
    target_status: targetStatus,
  });
  return response.data.data;
}
